/* globals _ */

import Collection from './base';

const { each, extend } = _;

export default Collection.extend( {
	preinitialize: function( models, options = {} ) {
		Collection.prototype.preinitialize.apply( this, arguments );

		this.subset = options.subset || new Collection();
		extend( this.subset.libraries, options.libraries || {} );

		options.model = this.subset.model;
		options.comparator = this.subset.comparator;
	},

	initialize: function() {
		this.predicates = {};

		this.collection = this.subset.constructor;

		this.on( 'reset update', this.filterSubset );
		this.on( 'sort', () => this.subset.sort() );
	},

	filterSubset: function() {
		var results = this.models;

		each( this.predicates, ( [ predicate, precheck ] ) => {
			// If precheck is not set or passes, run the predicate
			// The precheck is to see if a model-by-model check is needed
			if ( ! precheck || precheck() ) {
				results = results.filter( predicate );
			}
		} );

		this.subset.set( results );
	},

	withPredicate: function( name ) {
		var results = this.models;

		if ( this.predicates[ name ] ) {
			let [ predicate, precheck ] = this.predicates[ name ];
			if ( ! precheck || precheck() ) {
				results = results.filter( predicate );
			}
		}

		return new this.collection( results );
	},

	addPredicate: function( name, predicate, precheck ) {
		this.predicates[ name ] = [ predicate, precheck ];

		this.trigger( 'predicate:' + name );

		this.filterSubset();
	},

	removePredicate: function( name ) {
		delete this.predicates[ name ];

		this.trigger( 'predicate:' + name );

		this.filterSubset();
	},
} );
